/* EMP base — AJAX add-to-cart that opens Dawn's cart drawer.
   - Opens the drawer when the custom header cart icon is clicked.
   - Intercepts any form[data-emp-ajax] submit, adds via the Cart API,
     re-renders Dawn's <cart-drawer> and opens it, and refreshes the header count.
   Falls back to a normal submit if no <cart-drawer> is present. */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }

  // Open drawer from the custom header cart icon
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.emp-hd__cart');
    if (!link) return;
    var d = drawer();
    if (d) { e.preventDefault(); d.open(link); }
  });

  function refreshHeaderCount() {
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-emp-ajax]');
    if (!form) return;
    var d = drawer();
    if (!d) return; // no drawer → let it submit normally to /cart

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        if (res.status) {
          // e.g. sold out / not available — surface the message
          alert(res.description || res.message || 'Impossible d’ajouter au panier.');
          return;
        }
        d.classList.remove('is-empty');
        if (typeof d.renderContents === 'function') { d.renderContents(res); }
        else { d.open(); }
        refreshHeaderCount();
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        form.submit();
      });
  });
})();
